import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const bannerHeight = gridSize * 7;
export const BANNER_NAME = 'IP_BLOCK_LISTING_BANNER';
